export default {
  classes: {
    container: 'switch-container focus:outline-none',
    switch: 'switch',
    label:
      'relative block h-4 bg-white border border-solid cursor-pointer border-gray switch-label',
  },
}
